import { AU1_STAGING_HOSTS } from '@fleet/environment';
import { FLEET_VERSION } from '@fleet/version';

export const environment = {
  production: true,
  hmr: false,
  version: FLEET_VERSION,
  minTokenExpiry: 60,
  fleetProduct: 'TRAVELLER',
  envName: 'staging-au1',
  ...AU1_STAGING_HOSTS,
};
